
































































































































import Vue from 'vue'

import { Credentials, params, Profile, types } from '@/components/registration/module/types'

export default Vue.extend({
  computed: {
    currentUser(): Profile {
      return this.$store.getters.currentUser
    },
    isSignedIn(): boolean {
      return this.$store.getters.isSignedIn
    },
  },
  mounted() {
    this.passwordIsReset = false
  },
  data() {
    return {
      usernameOrEmail: '',
      passwordIsReset: false,
      resetPasswordError: false,
      errorMsg: '',
    }
  },
  methods: {
    resetPassword() {
      const http = this.$store.getters.http
      http
        .post('/api/auth/users/reset_password', {
          user: { login: this.usernameOrEmail, language: this.$i18n.locale },
        })
        .then(({ data }) => {
          if (data.ok) {
            this.passwordIsReset = true
            console.log(data)
          } else {
            this.errorMsg = data.error
            this.resetPasswordError = true
          }
        })
        .catch(err => {
          this.resetPasswordError = true
          if (err.response) {
            if (err.response.data && err.response.data.error) {
              this.errorMsg = err.response.data.error
            }
          }
        })
    },
    errorText(language) {
      if (language == 'ar') {
        if (this.errorMsg == 'user not found') {
          return 'تعذر العثور على بيانات لاسم المستخدم / البريد الإلكتروني'
        } else {
          return 'خطأ عام في إعادة تعيين كلمة المرور'
        }
      } else {
        if (this.errorMsg == 'user not found') {
          return 'Zum Benutzernamen/Email konnten keine Daten gefunden werden.'
        } else {
          return 'Allgemeiner Fehler beim Zürücksetzen des Kennworts.'
        }
      }
    },
    retry() {
      this.passwordIsReset = false
      this.resetPasswordError = false
      this.errorMsg = ''
    },
  },
})
